module.exports = {
      id: "7a58952c62735603604efe3d4aa39e93kitchenEquipment-ceramic-hob.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#7a58952c62735603604efe3d4aa39e93kitchenEquipment-ceramic-hob.svg",
      toString: function () {
        return this.url;
      }
    }